module.exports = __webpack_public_path__ + "./docs/img/icon-getter.79ff26dbf643768287be384649f38bf3.svg";